import styled, { css } from 'styled-components';

export const PermissionContainer = styled.div.attrs(() => ({
  className: 'MemberConfigContainer',
}))`
  display: flex;
  flex-flow: wrap column;
  padding: 0 20px 20px;

  ${({ theme }) => theme.breakPoints.tablet} {
    padding: 0 32px 30px;
  }
`;

export const PermissionGroup = styled.div.attrs(() => ({
  className: 'MemberConfigGroup',
}))`
  display: flex;
  flex-direction: column;

  & h3 {
    color: #4A4A4A;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 28px;

    ${({ theme }) => theme.breakPoints.tablet} {
      margin-bottom: 34px;
    }
  }
`;

export const PermissionItem = styled.div.attrs(() => ({
  className: 'MemberConfigItem',
}))`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 16px;
`;

export const PermissionItemToggle = styled.div.attrs(() => ({
  className: 'MemberConfigItemToggle',
}))`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 16px;
`;

export const PermissionTitle = styled.h4.attrs(() => ({
  className: 'MemberConfigTitle',
}))`
  color: ${({ theme }) => theme.colors.shadeDark};
  font-size: 16px;
  font-weight: bold;
  line-height: 21px;
  margin: 0;
  margin-bottom: 4px;
`;

export const PermissionText = styled.p.attrs(() => ({
  className: 'MemberConfigText',
}))`
  color: #4A4A4A;
  font-size: 14px;
  font-weight: normal;
  line-height: 18px;
  margin: 0;
  margin-right: 10px;
`;

export const SwitcherWrapper = styled.span.attrs(() => ({
  className: 'MemberConfigSwitcherWrapper',
}))`
  margin-left: 20px;
  width: 58px;
`;

export const SaveBtn = styled.div.attrs(() => ({
  className: 'MemberConfigSaveButtonWrapper',
}))`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  margin-top: 30px;

  & button {
    width: 120px !important;
  }
`;

export const StylesImageModalResultsUpdateMember = css`
  margin: 30px auto;
  width: 60px;
  height: auto;
`;
